import get from 'lodash.get';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectShipment = (state) => get(state, 'shipment') || emptyObject;
